export const initialState = {
    isInitialized: false
};